




























































import Vue from "vue";
import DocOCR from "@tecnike/dococr";
import { TipoClienteArray } from "@/entities/tipo-cliente";
import { NazioneArray } from "@/entities/nazione";
import Cliente from "@/entities/cliente";
import DocOCRLogic from "@/logic/doc-ocr";
import Api from "@/api/api";
import Catasto from "@/data/catasto";
import Locale from "@/data/locale";

export default Vue.extend({
  data () {
    return {
      alertNoScan: false,

      cliente: {
        tipo: "Maschio",
        cognome: "",
        nome: "",
        codiceFiscale: "",
        partitaIva: "",
        luogoNascita: "",
        dataNascita: "",
        residenza: {
          toponimo: "VIA",
          indirizzo: "",
          numeroCivico: "",
          cap: "",
          comune: "",
          provincia: "",
          nazione: "ITALIA"
        },
        recapiti: {
          email: "",
          cellulare: "",
          telefonoFisso: ""
        },
        note: ""
      } as Cliente,

      tipi: TipoClienteArray,
      nazioni: NazioneArray,

      localeIt: Locale.QInputDateLocaleIt
    };
  },

  methods: {
    fillFromScanResult (scanResult: DocOCR.DocOCRResult): void {
      this.cliente = DocOCRLogic.processResult(scanResult);
    },

    async createCustomerAsync (): Promise<void> {
      this.$q.loading.show();

      // TODO: fare per benino.
      let dtoType: "M" | "F" | "D" = "M";
      switch (this.cliente.tipo) {
        case "Maschio":
          dtoType = "M";
          break;
        case "Femmina":
          dtoType = "F";
          break;
        case "Ditta":
          dtoType = "D";
          break;
      }

      // TODO: fare per benino.
      const risultatiCatasto = Catasto.search(this.cliente.luogoNascita);
      if (risultatiCatasto.length === 0) {
        this.$q.notify({
          progress: true,
          message: `Luogo di nascita non valido, nessun comune trovato per "${this.cliente.luogoNascita}"`,
          type: "negative"
        });
        this.$q.loading.hide();
        return;
      }

      const codiceCatastaleNascita = risultatiCatasto[0].code;
      const creationResult = await Api.customer.newAsync({
        /* eslint-disable */
        as_producer_id: '5443',
        toponym: this.cliente.residenza.toponimo,
        address: this.cliente.residenza.indirizzo,
        civic_number: this.cliente.residenza.numeroCivico,
        cap: this.cliente.residenza.cap,
        comune: this.cliente.residenza.comune,
        province: this.cliente.residenza.provincia,
        nation: this.cliente.residenza.nazione,
        email: this.cliente.recapiti.email,
        mobile_phone: this.cliente.recapiti.cellulare,
        fixed_phone: this.cliente.recapiti.telefonoFisso,
        note: this.cliente.note,
        type: dtoType,
        lastname: this.cliente.cognome,
        firstname: this.cliente.nome,
        description: this.cliente.nome + ' ' + this.cliente.cognome,
        fiscal_code: this.cliente.codiceFiscale,
        piva: this.cliente.partitaIva,
        birthplace: codiceCatastaleNascita,
        birthday: this.cliente.dataNascita
        /* eslint-enable */
      });

      // Se ha la proprietà "id" è andato ben e c'è il cliente,
      // altrimenti c'è stato un qualche errore.
      if (!creationResult.error && creationResult.id) {
        this.$router.push("/customer/" + creationResult.id);
      } else {
        const message = creationResult.message || "Si è verificato un errore, riprovare. (codice errore: " + creationResult.error + ")";

        this.$q.notify({
          progress: true,
          message: message,
          type: "negative"
        });

        // Se è ha errore multipli o di validazione, uno per volta si mostrano.
        if (creationResult.errors) {
          for (const error of creationResult.errors) {
            this.$q.notify({
              progress: true,
              message: error,
              type: "negative"
            });
          }
        }
      }

      this.$q.loading.hide();
    }
  }
});
